export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Vest_Metalness.984c3f59.tga";